export enum TableResponsiveTypeColumnEnum {
  TITLE = 'title',
  SUBTITLE = 'subtitle',
  HAS_LABEL_ON_MOBILE = 'has_label_on_mobile',
  HIDE_ON_MOBILE = 'hide_on_mobile',
  IMAGE = "IMAGE",
}
